import React from 'react'
import './style.css'
import Family from './Family';
import Documents from './Documents';

const FamilyDocumentsSection = ({data}) => {
    const { patientData } = data || {};
  return (
    <div className='family-documents-container mt-4'>
        <Family familyHistory={patientData?.familyMedicalHistory} />
        <Documents documents={patientData?.files} />
    </div>
  )
}

export default FamilyDocumentsSection